export const convertToHtml = (data: string) => {
  data = data.replace(/\n/g, '<br />')
  return <p dangerouslySetInnerHTML={{ __html: data }} />
}
